module.exports = __webpack_public_path__ + "static/media/newProduct.7e1ab550.jpeg";